import { useDispatch } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import { jbColors } from '../../theme/jbColors';
import { closeModal } from '../../reducers/modalReducer';
import { theme } from '../../theme';

const styles = {
  dialogPaper: {
    '& .MuiMenu-paper': {
      maxWidth: '28%',
      maxHeight: '80%',
    },
  },
  content: {
    '& > *:not(:first-child)': {
      marginTop: theme.spacing(2),
    },
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  title: {
    marginTop: theme.spacing(1.5),
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  divider: {
    flex: 1,
    marginTop: theme.spacing(2),
    backgroundColor: jbColors.core.reflexBlue[70],
  },
  listItem: {
    marginTop: theme.spacing(1),
  },
};

export const TermsAndConditionsDialog = () => {
  const dispatch = useDispatch();

  const handleOk = () => {
    dispatch(closeModal()); // close self
  };

  return (
    <Dialog
      scroll={'paper'}
      id="terms-of-use-dialog"
      maxWidth={false}
      open={true}
      fullWidth={true}
      aria-labelledby="terms-of-use-dialog-area"
      PaperProps={{ square: true }}
      sx={styles.dialogPaper}
      onBackdropClick={() => dispatch(closeModal())}
    >
      <Typography style={{ padding: theme.spacing(4), paddingBottom: theme.spacing(2) }} variant={'h5'}>
        TERMS OF USE FOR THE PROVISIONING OF THE JB MOBILE INSIGHTS APP SERVICES
        <Divider sx={styles.divider} />
      </Typography>
      <DialogContent sx={styles.content}>
        <Typography style={{ whiteSpace: 'pre-line' }}>
          {`Before access to the JB Mobile Insights App can be granted, `}
          <strong>
            the applicable Country Guidelines must be consulted. If access is permitted, the RM must document in CLM,
          </strong>{' '}
          {' for each partner relationship:'}{' '}
        </Typography>
        <ul>
          <li>
            <Typography> how the prospect/client has learned of the Insights App;</Typography>
          </li>
          <li style={styles.listItem}>
            <Typography>the prospect’s/client’s express request to access the App and all its publications;</Typography>
          </li>
          <li style={styles.listItem}>
            <Typography>how and when the prospect/client approached the RM with regards to the App.</Typography>
          </li>
        </ul>
        <Typography style={{ whiteSpace: 'pre-line' }} data-testid={'terms-and-conditions-paragraph'}>
          {`Where local regulations allow for active solicitation of publications,
please document the qualified prospect/client contact with a
corresponding contact note.
          
          You confirm that access to the app was provided in line with
applicable local regulations.

You confirm that all information captured in CLM are true and to the
best of your knowledge.
          
          By generating the Insights Activation Code, you confirm that the
prospect/client has expressly requested access to the publications
that are available to them based on their respective location through
the JB Insights App and that `}
          <strong>you have logged this request in CLM (as per the above).</strong>
        </Typography>
      </DialogContent>
      <DialogActions style={{ margin: theme.spacing(2) }}>
        <Button
          id={'close-TOC-modal'}
          data-testid={'close-TOC-modal'}
          variant="contained"
          onClick={handleOk}
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
